var Uploader = (function(window) {
    //'use strict';

    var
      fileNames = null,
      fileMisc = null,
      fileSelect = null,
      fileDrag = null,
      fileSubmit = null,
      filesArray = [];

    var compatible = {
        fileAPI: window.File && window.FileList && window.FileReader,
        XHR: function() {
            var xhr = new XHRHttpRequest();
            return xhr.upload ? true : false;
        }
    };

    var isAllowedFileType = function(file) {
        var allowedTypes = {
            doc: 'application/msword',
            pdf: 'application/pdf',
            xls: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            ppt: 'application/vnd.ms-powerpoint.template.macroenabled.12',
            jpg: 'image/jpeg',
            gif: 'image/gif',
            png: 'image/png',
            zip: 'application/x-zip-compressed',
            docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
video: 'video/'
        },
        isAllowed = false;
        for (var type in allowedTypes) {
            if (file.type.indexOf(allowedTypes[type]) > -1) {
                file.simpleType = type;
                isAllowed = true;
            }
        }

        return isAllowed;
    };

    var displayFileName = function(element, file) {
        util.outputMsg(element, '<p>' + file.name + '</p>');
    };

    var displayFileIcon = function(element, file) {
        var typeDiv = util.id('file-type');
        typeDiv.classList.add('type-' + file.simpleType);
    };

    var displayFileExt = function() {
        // check if extensions a different
            // if multiple extensions
                // set #file-type to generic icon
                // set #file-ext label to multiple file
            // else same extensions
                // set #file-type to extension icon/
                // set #file-ext label to extension name
    };

    var addDragClass = function(event) {
        event.stopPropagation();
        event.preventDefault();
        return event.type === 'dragover' ? event.target.classList.add('hover') : event.target.classList.remove('hover');
    };

    var addFileToInput = function(input, event) {
        event.stopPropagation();
        event.preventDefault();

        addDragClass(event);
        filesArray.push(event.target.files || event.dataTransfer.files)
        //input.files = event.target.files || event.dataTransfer.files;
    };

    var fileHandler = function(names, misc, files) {
        //Button for document WWP upload
        var documentUpload = util.id('btn-upload'),
            linkUpload = util.id('link-upload');

        documentUpload.setAttribute("disabled", "true");

        //var files = (event.target.files || event.dataTransfer.files).toArray();

        if(files.length > 1)
            return;

        var fileInputDiv = util.id('file-inputs'),
            progressBar = util.id('file-progress'),
            errors = 0;

        names.innerHTML = '';

        for (var i = 0; i < files.length; i++) {
            var file = files[i];
            if (isAllowedFileType(file)) {
                displayFileName(names, file);
                displayFileIcon(misc, file);
            } else {
                util.outputMsg(names, names.getAttribute('uploader-invalidformat'));
                errors++;
            }
        }

        //if there is no files selected
        if(typeof files[0] == 'undefined')
        {
            errors++;
        }

        //Remove all file inputs
        while (fileInputDiv.firstChild) {
            fileInputDiv.removeChild(fileInputDiv.firstChild);
        }

        progressBar.value = 0;

        if (errors === 0) {

            var uploadElement = util.id('uploader');
            var uploadForm = util.id('file-form');
            var uploadDocumentURL = uploadElement.getAttribute('data-js-uploader-url');

            linkUpload.classList.remove('another-file');
            documentUpload.classList.add('loading-file');
            linkUpload.classList.add('loading-file');

            uploadForm.reset();

            uploadForm.classList.add('loading-file');

            var formData = new FormData();

            for (var i = 0; i < files.length; i++) {
                formData.append(files[i].name, files[i]);
            }


            var xhr = new XMLHttpRequest();
            xhr.open('POST', uploadDocumentURL, true);


            xhr.upload.onprogress = function(e) {
            if (e.lengthComputable) {
                progressBar.value = (e.loaded / e.total) * 100;
                progressBar.textContent = progressBar.value; // Fallback for unsupported browsers.
              }
            };

            xhr.onload = function(e) {

                var res = e.target.responseText.split("<script");
                var myIds = JSON.parse(res[0]);

                for (var i = 0; i < myIds.length; i++) {
                    (function(i) {
                        var input = document.createElement('input');
                        input.setAttribute('name', 'fields[fichier][]');
                        input.setAttribute('value', myIds[i]);
                        input.setAttribute('type', 'hidden');
                        fileInputDiv.appendChild(input);
                    })(i);
                }
            };

            xhr.onreadystatechange = function(e) {
                documentUpload.classList.remove('loading-file');
                documentUpload.removeAttribute('disabled');
                linkUpload.classList.remove('loading-file');
                linkUpload.classList.add('another-file');
            }

            // unexpected token <
            xhr.send(formData);
        }

        // displayFileExt();
    };

    var getElements = function() {
        fileNames = util.id('file-names');
        fileMisc = util.id('file-misc');
        fileSelect = util.id('file-select');
        fileDrag = util.id('file-drag');
        fileSubmit = util.id('file-submit');
    };

    var init = function() {
        if (!compatible.fileAPI) {
            console.warn('This browser is not compatible with the File API.');
        }
        if (!compatible.XHR) {
            console.warn('This browser is not compatible with the XHR API.');
        } else if (compatible.fileAPI && compatible.XHR) {
            getElements();

            //fileSelect.addEventListener('change', function(event) { fileHandler(fileNames, fileMisc, event); });
            //fileDrag.addEventListener('drop', function(event) { addFileToInput(fileSelect, event); });
            fileDrag.addEventListener('dragover', function(event) { addDragClass(event) });
            fileDrag.addEventListener('dragleave', function(event) { addDragClass(event) });

            fileDrag.addEventListener('drop', function(event) {

                event.stopPropagation();
                event.preventDefault();

                fileHandler(fileNames,  fileMisc, event.dataTransfer.files);
            });
            fileSelect.addEventListener('change', function(event) { fileHandler(fileNames, fileMisc, this.files); });
        }

        $('.gr-select').customSelect();

    };

    return {init: init};
})(window, document);
